import { api } from "@/lib/api";
export const listMyApp = async () => (await api.get("/ambassadors/me")).data;
export const applyAmbassador = async (payload) => (await api.post("/ambassadors/apply", payload)).data.application;
export const rescore = async () => (await api.post("/ambassadors/me/rescore")).data;
export const adminQueue = async (status) => (await api.get(`/ambassadors/admin/queue${status?`?status=${status}`:''}`)).data.items;
export const adminApprove = async (id, notes) => (await api.post(`/ambassadors/admin/${id}/approve`, { notes })).data;
export const adminReject = async (id, notes) => (await api.post(`/ambassadors/admin/${id}/reject`, { notes })).data;
export const publicList = async () => (await api.get("/ambassadors/public")).data.items;
export const publicProfile = async (slug) => (await api.get(`/ambassadors/public/${slug}`)).data.profile;

// Founder ↔ Ambassador invitations (Cycle P4)
export const inviteAmbassador = async ({ ambassador_slug, product_id = null, message }) =>
  (await api.post("/ambassadors/invitations", { ambassador_slug, product_id, message })).data.invitation;
export const listSentInvitations = async () =>
  (await api.get("/ambassadors/invitations/sent")).data.items;
export const listReceivedInvitations = async () =>
  (await api.get("/ambassadors/invitations/received")).data.items;
export const respondInvitation = async (id, outcome) =>
  (await api.post(`/ambassadors/invitations/${encodeURIComponent(id)}/respond`, { outcome })).data.invitation;

export const listMyProductAmbassadorships = async () =>
  (await api.get(`/ambassadors/me/products`)).data;

export const listMyReferredSubscriptions = async (productId) =>
  (await api.get(`/ambassadors/me/subscriptions`, { params: productId ? { product_id: productId } : {} })).data;
